/**
 * Today's date in the USER's time zone, as 'YYYY-MM-DD'.
 *
 * `new Date().toISOString().slice(0, 10)` is the UTC date: in Lisbon it is still
 * yesterday for the first hour after midnight in summer (UTC+1). Use this helper
 * for date DEFAULTS the user sees and accepts.
 *
 * Note (2026-10-09 review): a few older screens still use the UTC form, and some of
 * them mirror a backend "not in the future" check that uses the SERVER's date (UTC on
 * Azure) — aligning those needs the backend and the frontend changed together
 * (OPEN_ITEMS follow-up), so they were deliberately not swept here.
 */
export function localTodayISO(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
